// true only while react-snap is taking its HTML snapshot
export const IS_SNAP =
  typeof navigator !== "undefined" && navigator.userAgent.includes("ReactSnap");